
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Pedido } from '@app/models/pedido.model';

@Injectable()
export class PedidoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(pedido: Pedido): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'configuracoes/pedido', pedido).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http
      .delete<any>(this.URL_API + `configuracoes/pedido/${id}`);
  }

  obterPorId(id: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `configuracoes/pedido/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http
      .get<any>(this.URL_API + `configuracoes/pedido/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

}
